function OnlineUsers(props) {
  const onlineUsers = props.onlineUsers;
  const meetingAccessRequests = props.meetingAccessRequests;
  const userInfo = props.userInfo;

  const handleMuteUserAudio = props.handleMuteUserAudio;
  const handleMuteUserVideo = props.handleMuteUserVideo;
  const handleBanUser = props.handleBanUser;
  const handleEjectUser = props.handleEjectUser;
  const handleAcceptRequestToJoin = props.handleAcceptRequestToJoin;

  console.log("User Info", userInfo);
  console.log("<OnlineUsers>", onlineUsers);

  return (
    <div className="bg-white w-full h-full relative p-4">
      <h1 className="text-lg font-bold">People</h1>

      {meetingAccessRequests.length > 0 ? (
        <div>
          <div className="flow-root mt-6">
            <div className="mb-6 text-sm text-gray-600">
              Requesting to Join ({meetingAccessRequests.length})
            </div>
            <ul role="list" className="-my-5 divide-y divide-gray-200">
              {meetingAccessRequests.map(request => (
                <li key={request.name} className="py-4">
                  <div className="flex items-center space-x-4">
                    <div className="flex-shrink-0">
                      <div className="h-8 w-8 rounded-full bg-yellow-600 text-white font-bold text-lg text-center">
                        {request.name[0].toUpperCase()}
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-gray-900 truncate">{request.name}</p>
                    </div>
                    <div className="space-x-1">
                      <button
                        onClick={() => {
                          handleAcceptRequestToJoin(request._id);
                        }}
                        className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                      >
                        Accept
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-6"></div>
        </div>
      ) : (
        ""
      )}

      <div>
        <div className="flow-root mt-6">
          <div className="mb-6 text-sm text-gray-600">
            Currently in the Meeting ({onlineUsers.length})
          </div>
          <ul role="list" className="-my-5 divide-y divide-gray-200">
            {onlineUsers.map(onlineUser => (
              <li key={onlineUser.name} className="py-4">
                <div className="flex items-center space-x-4">
                  <div className="flex-shrink-0">
                    {onlineUser.profilePic ? (
                      <img className="h-8 w-8 rounded-full" src={onlineUser.profilePic} alt="" />
                    ) : (
                      <div className="h-8 w-8 rounded-full bg-yellow-600 text-white font-bold text-lg text-center">
                        {onlineUser.name[0].toUpperCase()}
                      </div>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-900 truncate">{onlineUser.name}</p>
                    <p className="text-sm text-gray-500 truncate">{onlineUser.role}</p>
                  </div>
                  {onlineUser._id === userInfo._id ? (
                    ""
                  ) : userInfo.isAdmin ? (
                    <div className="space-x-1">
                      <button
                        onClick={() => {
                          handleMuteUserAudio(onlineUser._id, onlineUser.disableAudio);
                        }}
                        className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                      >
                        {onlineUser.disableAudio ? "Enable" : "Disable"} Audio
                      </button>

                      <button
                        onClick={() => {
                          handleMuteUserVideo(onlineUser._id, onlineUser.disableVideo);
                        }}
                        className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                      >
                        {onlineUser.disableVideo ? "Enable" : "Disable"} Video
                      </button>

                      <button
                        onClick={() => {
                          handleEjectUser(onlineUser._id);
                        }}
                        className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                      >
                        Eject
                      </button>

                      {/* <button
                        onClick={() => {
                          handleBanUser(onlineUser._id);
                        }}
                        className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
                      >
                        Ban
                      </button> */}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-6">
          {/* <a
            href="#"
            className="w-full flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Load more
          </a> */}
        </div>
      </div>
    </div>
  );
}

export default OnlineUsers;
